import { useEffect, useRef } from "react";
import { useLocation, matchPath } from "react-router-dom";
import { Path } from "../../routes/PagePath";

// スクロールをトップに戻すページのパスリスト
const scrollToTopPageList = [Path.senderEmailConfirm, Path.sendEmailCompleted];

/**
 * 特定のページでスクロールをトップに戻すカスタムフック
 * @returns ref スクロール対象の要素に設定するref
 */
export const useScrollToTop = () => {
    const { pathname } = useLocation();
    const ref = useRef<HTMLDivElement>(null);

    const isScrollToTop = scrollToTopPageList.some((path) =>
        matchPath(path, pathname)
    );

    useEffect(() => {
        if (ref.current && isScrollToTop) {
            ref.current.scrollTo({ top: 0 });
        }
    }, [isScrollToTop]);

    return ref;
};
